import { Address } from "@core/types";
import { useAuth } from "../contexts/auth-context";
import { useGetCustomerAddresses } from "../providers/CustomerAddresses";
import { useCustomerAddressesStorageData } from "../providers/customerAddressesStorage";
import { getAddressByIdBasedOnAuthStatus } from "../utils/getAddressByIdBasedOnAuthStatus";
import { useEffect, useState } from "react";

/**
 * Хук для получения текущего адреса из storage
 *
 * Если адрес не найден, то возвращает null
 *
 * Главная проблема с текущем хуком в том, что при первых рендерах всегда будет null - т.к. адреса еще не загрузились.
 */
const useGetCurrentAddress = () => {
  const { user, isUserAuthenticated } = useAuth();
  const [currentAddress, setCurrentAddress] = useState<Address | null>(null);
  const { unAuthedCustomerAddresses, currentShippingAddressId } = useCustomerAddressesStorageData();
  const isAuthenticated = Boolean(isUserAuthenticated);

  const { data: customerAddresses, isLoading: isCustomerAddressesLoading } = useGetCustomerAddresses({
    customerId: user?.id,
    options: { enabled: isAuthenticated },
  });

  useEffect(() => {
    if (!currentShippingAddressId) {
      setCurrentAddress(null);
      return;
    }
 
    if (isAuthenticated && isCustomerAddressesLoading) {
      return;
    }

    setCurrentAddress(
      getAddressByIdBasedOnAuthStatus(
        isAuthenticated,
        currentShippingAddressId,
        customerAddresses ?? [],
        unAuthedCustomerAddresses,
      ),
    );
  }, [
    isAuthenticated,
    currentShippingAddressId,
    unAuthedCustomerAddresses,
    customerAddresses,
    isCustomerAddressesLoading,
  ]);

  return currentAddress;
};

export default useGetCurrentAddress;
